import { render, staticRenderFns } from "./Authoritymanagement.vue?vue&type=template&id=416c11be&scoped=true&"
import script from "./Authoritymanagement.vue?vue&type=script&lang=js&"
export * from "./Authoritymanagement.vue?vue&type=script&lang=js&"
import style0 from "./Authoritymanagement.vue?vue&type=style&index=0&id=416c11be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416c11be",
  null
  
)

export default component.exports